import { DateTime } from 'luxon';

import { assertNever, PaymentFrequency, ReportingTimezone } from '@willow/types-iso';

/**
 * Pass `timezone` when `firstDueDate` comes from a snapshot/loan translated to the owner timezone —
 * month arithmetic must run in that zone or the result drifts across DST transitions (see
 * getStatementPeriodStart in shared-node).
 */
export const getNextPaymentDueDate = (
  firstDueDate: Date,
  amortizationMonth: number,
  paymentFrequency: PaymentFrequency,
  timezone: ReportingTimezone = 'UTC',
): Date => {
  switch (paymentFrequency) {
    case 1:
      // For anything less than 12, still return the first due date
      // First due date happens on amortization month 12
      // Second due date happens on amortization month 24
      return DateTime.fromJSDate(firstDueDate)
        .setZone(timezone)
        .plus({ years: Math.max(Math.floor(amortizationMonth / 12) - 1, 0) })
        .toJSDate();
    case 12:
      return DateTime.fromJSDate(firstDueDate)
        .setZone(timezone)
        .plus({ months: amortizationMonth - 1 })
        .toJSDate();
    default:
      assertNever(paymentFrequency);
  }
};
